module.exports = __webpack_public_path__ + "img/ikon1.891ef8c3.png";